export default (function () {
  return {
    metaTags: [{
      productos: {
        title: 'Productos - Tienda en línea | Studio 4x4'
      },
      'verificacion-de-compra': {
        title: 'Verificación de compra - Tienda en línea | Studio 4x4'
      },
      'proceso-de-compra': {
        title: 'Proceso de compra - Tienda en línea | Studio 4x4'
      },
      'cuenta/': {
        title: 'Mi cuenta - Tienda en línea | Studio 4x4'
      },
      'cuenta/compra': {
        title: 'Mis compras - Tienda en línea | Studio 4x4'
      },
      'cuenta/direccion/': {
        title: 'Mi dirección - Tienda en línea | Studio 4x4'
      },
      'cuenta/facturacion': {
        title: 'Facturación - Tienda en línea | Studio 4x4'
      }
    }],
    currentRoute: null,
    current: {},
    default: {
      title: 'Studio 4x4',
      meta: {
        description: {
          name: 'description',
          content: 'Bienvenido a Studio 4x4'
        },
        'og:title': {
          name: 'og:title',
          content: 'Studio 4x4'
        },
        'og:description': {
          name: 'og:description',
          content: 'Bienvenido a Studio 4x4'
        },
        'og:locale': {
          name: 'og:local',
          content: 'es_MX'
        }
      }
    }
  };
});